import "./CuponContainer.styles.scss";
import { useContext, useEffect, useState } from "react";
import { CartContext } from "../../../contexts/CartContext";
import { GlobalContext } from "../../../contexts/GlobalContext";

const CuponContainer = () => {
  const { getCouponsByCartId, applyCouponOnCart, removeCouponFromCartItems } =
    useContext(CartContext);
  const { carrinho } = useContext(GlobalContext);
  const bag = carrinho.find(
    (bag) => !!bag.cartItems.find((cartItem) => !!cartItem.itemCouponId)
  );
  const itemCoupon = !!bag
    ? bag.cartItems.find((cartItem) => !!cartItem.itemCouponId).itemCoupon
    : undefined;

  const [couponCode, setCouponCode] = useState("");
  const [hasAvailableCoupons, setHasAvailableCoupons] = useState(false);
  const [checkingCoupons, setCheckingCoupons] = useState(true);

  useEffect(() => {
    const checkAvailableCoupons = async () => {
      setCheckingCoupons(true);
      const response = await getCouponsByCartId(carrinho[0].cartId);
      setHasAvailableCoupons(!!response && response.length > 0);
      setCheckingCoupons(false);
    };

    if (carrinho.length) {
      checkAvailableCoupons();
    } else {
      setCheckingCoupons(false);
    }
  }, [carrinho, getCouponsByCartId]);

  const handleApplyCoupon = (e) => {
    e.preventDefault();
    const code = couponCode.trim();
    if (!code) return;
    applyCouponOnCart(code);
  };

  const handleRemoveCoupon = (e) => {
    e.preventDefault();
    removeCouponFromCartItems();
  };

  if (checkingCoupons) return null;
  if (!itemCoupon && !hasAvailableCoupons) return null;

  return (
    <div className="aplicar-cupom-div">
      {!!itemCoupon ? (
        <div class="aplicar-cupom-applied">
          <p class="aplicar-cupom-applied-text">
            Cupom já aplicado!
            <br />
            <b>CÓDIGO: {itemCoupon.coupon.code}</b>
          </p>
          <button
            className="remover-cupom-button"
            title="Remover Cupom"
            onClick={handleRemoveCoupon}
          >
            <span>
              <span class="material-symbols-outlined">close</span>Remover
            </span>
          </button>
        </div>
      ) : (
        <>
          <div class="aplicar-cupom-form">
            <h1>Cupom de Desconto</h1>
            <span className="aplicar-cupom-description">
              Possui um cupom de desconto? Digite o código abaixo para
              aplicá-lo. É possível aplicar somente um cupom por compra.
            </span>
          </div>
          <form
            className="aplicar-cupom-control"
            onSubmit={handleApplyCoupon}
          >
            <input
              type="text"
              className="aplicar-cupom-input"
              placeholder="Digite o código do cupom"
              value={couponCode}
              onChange={(e) => setCouponCode(e.target.value)}
            />
            <button
              type="submit"
              className="aplicar-cupom-button"
              title="Aplicar Cupom"
            >
              <span class="material-symbols-outlined">arrow_forward</span>
            </button>
          </form>
        </>
      )}
    </div>
  );
};

export default CuponContainer;
